import TradeResponse from '../pages/TradeResponse.vue';
import TradeResponseInfo from '../pages/TradeResponseInfo.vue';

const tradeResponseRoutes = [
  {
    path: '/trade-response',
    name: 'لیست تقاضا',
    component: TradeResponse,
    meta: {
      roles: ['merchant', 'supplier'],
    },
  },
  {
    path: '/trade-response-info/:id',
    name: 'مشاهده جزییات',
    component: TradeResponseInfo,
    meta: {
      roles: ['merchant', 'supplier'],
    },
  },
];

export default tradeResponseRoutes;
